module.exports = __webpack_public_path__ + "static/img/6.507f816.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/preview/benjyfishy/6.png
// module id = Xlgk
// module chunks = 35